var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7771C12.825 14.7771 13.5315 14.4874 14.1195 13.9082C14.7065 13.3299 15 12.6344 15 11.8217C15 11.0089 14.7065 10.3129 14.1195 9.73366C13.5315 9.15538 12.825 8.86624 12 8.86624C11.175 8.86624 10.469 9.15538 9.882 9.73366C9.294 10.3129 9 11.0089 9 11.8217C9 12.6344 9.294 13.3299 9.882 13.9082C10.469 14.4874 11.175 14.7771 12 14.7771ZM12 29C11.8 29 11.6 28.9631 11.4 28.8892C11.2 28.8153 11.025 28.7168 10.875 28.5936C7.225 25.4166 4.5 22.4676 2.7 19.7466C0.9 17.0247 0 14.4815 0 12.1172C0 8.42293 1.2065 5.47983 3.6195 3.2879C6.0315 1.09597 8.825 0 12 0C15.175 0 17.9685 1.09597 20.3805 3.2879C22.7935 5.47983 24 8.42293 24 12.1172C24 14.4815 23.1 17.0247 21.3 19.7466C19.5 22.4676 16.775 25.4166 13.125 28.5936C12.975 28.7168 12.8 28.8153 12.6 28.8892C12.4 28.9631 12.2 29 12 29Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressLogo);
export default __webpack_public_path__ + "static/media/AddressLogo.c8bac48735264c24613be9cda9e7c152.svg";
export { ForwardRef as ReactComponent };